import { HTMLInputTypeAttribute, useState } from "react";
import { FaEye, FaEyeDropper, FaEyeSlash } from "react-icons/fa6";

type TextInputProps = {
  isMandatory?: boolean;
  type?: HTMLInputTypeAttribute;
  pattern?: string;
  minLength?: number;
  maxLength?: number;
  min?: number;
  max?: number;
  autoComplete?: string;
  labelText?: string;
  inputText?: string | number;
  isDisabled?: boolean;
  theme?: string;
  setInputText(inputText: string | number): void;
  rightButton?: React.ReactNode;
  onKeyDown?: (e: any) => void
  labelClassName?: string
};

const CommonTextInput = (props: TextInputProps) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => setShowPassword((prev) => !prev);

  const isPasswordType = props.type === "password";

  return (
    <div className="input-container input-container-text flex flex-col  h-full">
      {
        props.type != 'date' ?
          <label className={` ${props.labelClassName} ${props.inputText ? 'filled' : ''} `} htmlFor={props.labelText}>
            {props.labelText + (props.isMandatory ? '*' : '')}
          </label> : null
      }
      <input
        id={props.labelText}
        name={props.labelText}
        // type={props.type}
        autoComplete={props.autoComplete}
        type={isPasswordType && showPassword ? "text" : props.type}
        pattern={props.pattern}
        minLength={props.minLength}
        maxLength={props.maxLength}
        min={props.min}
        max={props.max}
        onKeyDown={props.onKeyDown}
        value={props.inputText}
        onChange={(e) => props.setInputText(e.target.value)}
        className={` ${props.rightButton ? 'relative' : ''} bg-white text-blueH1 border rounded-md w-full text-md p-2  h-full ${props.theme == 'orange' ? 'border-orangeH3 ' : 'border-gray300 '}`}
        required
        disabled={props.isDisabled}
      />
      {props.rightButton && !props.inputText && (
        <div className="flex-shrink-0 p-2 absolute top-1/2 -translate-y-1/2 right-0 text-orangeH3">
          {props.rightButton}
        </div>
      )}
      {isPasswordType && props.inputText && (
        <button
          type="button"
          onClick={handleTogglePassword}
          className="flex-shrink-0 p-2 absolute top-1/2 -translate-y-1/2 right-5 text-2xl text-orangeH3"
        >
          {showPassword ? <FaEyeSlash /> : <FaEye />}
        </button>
      )}

    </div>
  );
};

export default CommonTextInput;